import script from "./customer.vue?vue&type=script&setup=true&lang=js"
export * from "./customer.vue?vue&type=script&setup=true&lang=js"

import "./customer.vue?vue&type=style&index=0&id=05afabfe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05afabfe"]])

export default __exports__